import { Textarea } from 'components/forms/Textarea';
import { defaultInputPadding, TextInput } from 'components/forms/TextInput';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled, { css, CSSProperties } from 'styled-components';
import {
    backgroundColor,
    bodyBackgroundColor,
    borderColor,
    shadeBackgroundColor,
} from 'styles/theme';

export const dropdownTriggerStyles: CSSProperties = {
    marginTop: 5,
    borderRadius: 3,
    width: '100%',
    height: '100%',
};

const lightBackgroundStyle = css`
    border: 2px solid ${borderColor};
    border-width: 2px !important;
    padding-bottom: ${defaultInputPadding} !important;
    background-color: ${shadeBackgroundColor};
`;

const sharedTextInputStyleFn = ({
    $lightBackground,
}: {
    $lightBackground?: boolean;
}) => css`
    margin-top: 0.5rem;
    padding-left: 0.5rem;
    border-radius: 3px;
    background-color: ${backgroundColor};
    ${$lightBackground ? lightBackgroundStyle : ''}
`;

export const StyledTextInput = styled(TextInput)<{ $lightBackground?: boolean }>`
    ${sharedTextInputStyleFn}
`;

export const StyledTextArea = styled(Textarea)<{ $lightBackground?: boolean }>`
    border-radius: 3px;
    background-color: ${({ $lightBackground }) =>
        $lightBackground ? shadeBackgroundColor : backgroundColor};
`;
export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 3rem;
    border-bottom: 1px solid ${borderColor};
`;

export const Columns = styled.div`
    display: grid;
    column-gap: 4rem;

    @media ${MediaQueries.mediumAndUp} {
        grid-template-columns: auto 1fr;
    }
`;

export const CreateButtonContainer = styled.div`
    margin: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const FormInnerContent = styled.div`
    background-color: ${bodyBackgroundColor};
    padding: 1rem;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const Row = styled.div<{ $endColumn?: boolean }>`
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr ${({ $endColumn }) => ($endColumn ? 'auto' : '')};
`;

export const Heading = styled.div`
    font-weight: bold;
    font-size: 1.4rem;
`;
